import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { reduxForm, Field, formValueSelector } from 'redux-form';

import Content from '../common/template/content';
import ContentCard from '../common/template/contentCard';
import ContentCardHeader from '../common/template/contentCardHeader';
import ContentCardBody from '../common/template/contentCardBody';
import Row from '../common/layout/row';
import Grid from '../common/layout/grid';
import Table from '../common/table/table';
import THead from '../common/table/tHead';
import Tr from '../common/table/tr';
import Th from '../common/table/th';
import TBody from '../common/table/tBody';
import Td from '../common/table/td';
import ButtonTable from '../common/table/buttonTable';
import Button from '../common/button/button';
import Form from './freteForm';
import ReactExport from 'react-export-excel-fixed-xlsx';
import LabelAndInputMask from '../common/form/labelAndInputMask';

import { 
	setModoTela, initForm, setFiltro, salvar, excluir, 
	getLista, getListaVeiculo, getListaMotorista, 
	getListaCliente, getListaEndereco,
	getListaFreteDeslocamento, getListaUnidadeMedida
} from './freteActions';
import { 
	getLista as getListaUnidade
} from '../unidade/unidadeActions';
import { 
	getLista as getListaDistribudora
} from '../distribuidora/distribuidoraActions';
import { 
	getLista as getListaLocal
} from '../local/localActions';
import FormatUtils from '../common/formatUtils/FormatUtils';
import DateFormat from '../common/dateFormat/DateFormat';
import Select from '../common/form/select';

class Frete extends Component {

	state = {
		linhaSelecionada: null,
		pesquisar: ''
	}

    componentWillMount() {
        this.props.getLista();
		this.props.getListaVeiculo();
		this.props.getListaMotorista();
		this.props.getListaUnidade();
		this.props.getListaCliente();
		this.props.getListaEndereco();
		this.props.getListaFreteDeslocamento();
		this.props.getListaUnidadeMedida();
		this.props.getListaDistribudora();
		this.props.getListaLocal();

		let idInterval = setInterval(() => {
			this.props.getLista();
			this.props.getListaVeiculo();
			this.props.getListaMotorista();
			this.props.getListaUnidade();
			this.props.getListaCliente();
			this.props.getListaEndereco();
			this.props.getListaFreteDeslocamento();
			this.props.getListaUnidadeMedida();
			this.props.getListaDistribudora();
			this.props.getListaLocal();
		}, 60000);
		
		this.setState({
			...this.state,
			idInterval: idInterval
		});
	}
	
	componentWillUnmount() {

		if (this.state.idInterval) {
			clearInterval(this.state.idInterval);
		}
	
	}

    render() {

		const lista = this.filtrar();

        return (
            <div>
                <Content>
					{this.props.modoTela == 'cadastro' ? (
						<Form onSubmit={this.props.salvar} />
					) : null}
					{this.props.modoTela == 'exclusao' ? (
						<Form excluir onSubmit={this.props.excluir} />
					) : null}
					{this.props.modoTela == 'lista' ? this.lista() : null}
                </Content>
            </div>
        )
    }

	filtrar() {
		return this.props.lista.filter(item => {
			if (this.state.pesquisar
				&& !(`
					${DateFormat.formatarDataHoraSqlParaTela(item.datahora_agendamento)}
					${item.nome_motorista}
					${item.placa_veiculo}
					${item.placa_carreta1}
					${item.placa_carreta2}
					${FormatUtils.formatarValorTela(item.km_total, 0)}
					${FormatUtils.formatarValorTela(item.km_percorrida, 0)}
					${item.status}
				`).toUpperCase().includes(this.state.pesquisar.toUpperCase())) {
				return false;
			}
			if (this.props.filtro.data_inicial
				&& DateFormat.formatarDataTelaParaSql(DateFormat.formatarDataSqlParaTela(item.datahora_agendamento)) < DateFormat.formatarDataTelaParaSql(this.props.filtro.data_inicial)) {
				return false;
			}
			if (this.props.filtro.data_final
				&& DateFormat.formatarDataTelaParaSql(DateFormat.formatarDataSqlParaTela(item.datahora_agendamento)) > DateFormat.formatarDataTelaParaSql(this.props.filtro.data_final)) {
				return false;
			}
			return true;
		});
	}

	lista() {

		const ExcelFile = ReactExport.ExcelFile;
		const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
		const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;

		const lista = this.filtrar();
	
		return (
			<ContentCard>
				<ContentCardHeader>
					<Row>
						<Grid cols='6 6 4 2'>
							<Button
								text='Adicionar'
								type={'success'}
								icon={'fa fa-plus'}
								event={() => {
									this.props.setModoTela('cadastro', {});
									this.props.initForm({
										datahora_agendamento: DateFormat.formatarDataHoraSqlParaTela(DateFormat.getDataHoraAtual())
									});
								}} />
						</Grid>
						<Grid cols='6 6 3 2'>
							<ExcelFile
								filename={'Fretes'}
								element={
									<Button
									text='Exportar'
									type={'primary'}
									icon={'fa fa-plus'} />
								}>
								<ExcelSheet data={lista.map(item => ({
									...item, 
									datahora_agendamento: DateFormat.formatarDataHoraSqlParaTela(item.datahora_agendamento),
									km_total: FormatUtils.formatarValorTela(item.km_total, 0),
									km_percorrida: FormatUtils.formatarValorTela(item.km_percorrida, 0)
								}))} name='Fretes'>
									<ExcelColumn label='Data Hora' value='datahora_agendamento' />
									<ExcelColumn label='Motorista' value='nome_motorista' />
									<ExcelColumn label='Veículo' value='placa_veiculo' />
									<ExcelColumn label='Carreta 1' value='placa_carreta1' />
									<ExcelColumn label='Carreta 2' value='placa_carreta2' />
									<ExcelColumn label='Km Total' value='km_total' />
									<ExcelColumn label='Km Percorrido' value='km_percorrida' />
									<ExcelColumn label='Status' value='status' />
								</ExcelSheet>
							</ExcelFile>
						</Grid>
					</Row>

				</ContentCardHeader>
				<ContentCardBody>
					<Row>
						<LabelAndInputMask
							name='data_inicial'
							label='Data Inicial' placeholder='Informe a data'
							cols='12 6 2 2'
							mask='99/99/9999'
							maxWidth={130}
							value={this.props.filtro.data_inicial}
							onChange={data => {
								this.props.setFiltro({ ...this.props.filtro, data_inicial: data.target.value });
							}} />

						<LabelAndInputMask
							name='data_final'
							label='Data Final' placeholder='Informe a data'
							cols='12 6 2 2'
							mask='99/99/9999'
							maxWidth={130}
							value={this.props.filtro.data_final}
							onChange={data => {
								this.props.setFiltro({ ...this.props.filtro, data_final: data.target.value });
							}} />
					</Row>
					
					<input className='form-control'
						 placeholder='Pesquisar'
						 type='text'
						 value={this.state.pesquisar}
						 onChange={e => {
							 this.setState({ ...this.state, pesquisar: e.target.value });
						 }} />
					<Table responsive>
						<THead>
							<Tr>
								<Th colspan={1} alignCenter>Data Hora</Th>
								<Th colspan={1} alignCenter>Motorista</Th>
								<Th colspan={1} alignCenter>Veículo</Th>
								<Th colspan={1} alignCenter>Carreta 1</Th>
								<Th colspan={1} alignCenter>Carreta 2</Th>
								<Th colspan={1} alignCenter>Km Total</Th>
								<Th colspan={1} alignCenter>Km Percorrido</Th>
								<Th colspan={1} alignCenter>Status</Th>
								<Th colspan={1}></Th>
							</Tr>
						</THead>
						<TBody>
							{lista.map(item => {
								return (
									<Tr key={item.id} 
										className={`${this.state.linhaSelecionada == item.id ? 'hover' : ''}`}
										onMouseEnter={() => this.setState({ linhaSelecionada: item.id })} >
										<Td alignCenter>{DateFormat.formatarDataHoraSqlParaTela(item.datahora_agendamento)}</Td>
										<Td alignCenter>{item.nome_motorista}</Td>
										<Td alignCenter>{item.placa_veiculo}</Td>
										<Td alignCenter>{item.placa_carreta1}</Td>
										<Td alignCenter>{item.placa_carreta2}</Td>
										<Td alignCenter>{FormatUtils.formatarValorTela(item.km_total, 0)}</Td>
										<Td alignCenter>{FormatUtils.formatarValorTela(item.km_percorrida, 0)}</Td>
										<Td alignCenter>
											<span
												style={{
													display: 'inline-flex',
													alignItems: 'center',
													gap: '8px',
													padding: '6px 14px',
													borderRadius: '20px',
													fontSize: '12px',
													fontWeight: 'bold',
													backgroundColor: item.status == 'Finalizado'
														? '#e8f8ee'
														: item.status == 'Em Andamento'
															? '#e8f1ff'
															: '#fff8e1',
													color: item.status == 'Finalizado'
														? '#15803d'
														: item.status == 'Em Andamento'
															? '#1d4ed8'
															: '#b45309',
													border: `1px solid ${item.status == 'Finalizado'
															? '#b8e6c7'
															: item.status == 'Em Andamento'
																? '#bdd3ff'
																: '#ffe29a'
														}`
												}}
											>
												<span
													style={{
														width: '8px',
														height: '8px',
														borderRadius: '50%',
														backgroundColor: item.status == 'Finalizado'
															? '#22c55e'
															: item.status == 'Em Andamento'
																? '#3b82f6'
																: '#f59e0b',
														display: 'inline-block'
													}}
												/>

												{item.status}
											</span>
										</Td>
										<Td alignRight minWidth={200}>										
											<ButtonTable
												type={'warning'}
												icon={'fas fa-pencil-alt'}
												visible={this.state.linhaSelecionada == item.id}
												event={() => {
													this.props.setModoTela('cadastro', {
														...item,
														datahora_agendamento: DateFormat.formatarDataHoraSqlParaTela(item.datahora_agendamento),
														itens: (item.itens || []).map(freteItem => ({
															...freteItem,
															quantidade: FormatUtils.formatarValorTela(freteItem.quantidade, 2),
															km_total: FormatUtils.formatarValorTela(freteItem.km_total, 0),
															custo_km_rodado: FormatUtils.formatarValorTela(freteItem.custo_km_rodado || 0, 2)
														}))
													});
													this.props.initForm({
														...item,
														datahora_agendamento: DateFormat.formatarDataHoraSqlParaTela(item.datahora_agendamento),
														itens: (item.itens || []).map(freteItem => ({
															...freteItem,
															quantidade: FormatUtils.formatarValorTela(freteItem.quantidade, 2),
															km_total: FormatUtils.formatarValorTela(freteItem.km_total, 0),
															custo_km_rodado: FormatUtils.formatarValorTela(freteItem.custo_km_rodado || 0, 2)
														}))
													});
												}} />

											<ButtonTable
												type={'danger'}
												icon={'fas fa-trash-alt'}
												visible={this.state.linhaSelecionada == item.id}
												event={() => {

													this.props.setModoTela('exclusao', {
														...item,
														datahora_agendamento: DateFormat.formatarDataHoraSqlParaTela(item.datahora_agendamento),
														itens: (item.itens || []).map(freteItem => ({
															...freteItem,
															quantidade: FormatUtils.formatarValorTela(freteItem.quantidade, 2),
															km_total: FormatUtils.formatarValorTela(freteItem.km_total, 0)
														}))
													});
													this.props.initForm({
														...item,
														datahora_agendamento: DateFormat.formatarDataHoraSqlParaTela(item.datahora_agendamento),
														itens: (item.itens || []).map(freteItem => ({
															...freteItem,
															quantidade: FormatUtils.formatarValorTela(freteItem.quantidade, 2),
															km_total: FormatUtils.formatarValorTela(freteItem.km_total, 0)
														}))
													});
												}} />
										</Td>
									</Tr>
								)
							})}
						</TBody>
					</Table>
				</ContentCardBody>
			</ContentCard>
		);
	}

}

const mapStateToProps = state => ({
	sessao: state.auth.frete,
	modoTela: state.frete.modoTela,
	filtro: state.frete.filtro,
	lista: state.frete.lista
});
const mapDispatchToProps = dispatch => bindActionCreators({ 
	setModoTela, initForm, setFiltro, salvar, excluir, 
	getLista, getListaVeiculo, getListaMotorista, 
	getListaUnidade, getListaCliente, getListaEndereco,
	getListaFreteDeslocamento, getListaUnidadeMedida,
	getListaDistribudora, getListaLocal
}, dispatch);
export default connect(mapStateToProps, mapDispatchToProps)(Frete);
